import { render, staticRenderFns } from "./FlightPromotionsSection.vue?vue&type=template&id=3023e988&scoped=true"
import script from "./FlightPromotionsSection.vue?vue&type=script&lang=js"
export * from "./FlightPromotionsSection.vue?vue&type=script&lang=js"
import style0 from "./FlightPromotionsSection.vue?vue&type=style&index=0&id=3023e988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3023e988",
  null
  
)

export default component.exports